import { getIconProps, type IconProps } from '#types'

/**
 * Stacked cards with an error cross — no valid plan / payment instrument.
 *
 * Used as the placeholder glyph on the "Plan Required" gate.
 *
 * Path data is the designer's export (Figma `Icon set/cardserror`), whose own
 * bounds are 28.4167 x 25.75. The viewBox re-frames that ink inside the design's
 * 32x32 icon box — offsets are (32 - w)/2 and (32 - h)/2 — so the glyph renders
 * at the designed size and stays centred, like every other 32-framed icon here.
 * Sizing it directly to the ink bounds would render it ~12% oversized.
 *
 * @example
 * ```tsx
 * <CardsErrorIcon className="size-8 text-butter-gray-700" />
 * ```
 */
export function CardsErrorIcon({ strokeWidth = 1.75, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="-1.79165 -3.125 32 32">
      <path
        d="M5.95437 9.65931H9.76389M5.95437 13.424H9.76389M5.95437 17.1887H9.76389M27.5417 14.6789V3.3848C27.5417 1.99868 26.4046 0.875 25.002 0.875H9.76389H7.22421M23.7321 13.424V8.65539C23.7321 7.24977 23.7321 6.54696 23.4553 6.01008C23.2118 5.53783 22.8233 5.15388 22.3455 4.91326C21.8022 4.63971 21.091 4.63971 19.6687 4.63971H4.93849C3.51614 4.63971 2.80496 4.63971 2.26169 4.91326C1.78382 5.15388 1.3953 5.53783 1.15181 6.01008C0.875001 6.54696 0.875001 7.24977 0.875001 8.65539V18.1926C0.875001 19.5983 0.875001 20.3011 1.15181 20.838C1.3953 21.3102 1.78382 21.6942 2.26169 21.9348C2.80496 22.2083 3.51614 22.2083 4.93849 22.2083H12.3036H15.9861"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M26.2083 19.5417L20.875 24.875M26.2083 24.875L20.875 19.5417"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
